import { fmt } from "../../lib/api";
import { L, inputCls } from "./common";

const POLICY_FIELDS = [["adcr_window_days", "ADCR WINDOW", "d"], ["dos_days", "DAYS OF SUPPLY", "d"], ["drift_pct", "DRIFT SENSITIVITY", "%"]];

export default function FactSheetPolicyBlock({ f, set, pol }) {
  const on = !!f.policy_override;
  return (
    <div className="p-4 rounded-md border border-[#1E293B] space-y-3" data-testid="fact-policy">
      <div className="flex items-center justify-between gap-2">
        <div className="font-mono text-[10px] tracking-[0.2em] text-[#F59E0B]">OPERATING POLICY</div>
        <label className="flex items-center gap-2 text-sm cursor-pointer">
          <input type="checkbox" data-testid="fact-policy-override" className="w-5 h-5 accent-[#F59E0B]" checked={on} onChange={(e) => set("policy_override", e.target.checked)} />
          Override Global Policy
        </label>
      </div>
      <div className="grid grid-cols-3 gap-2">
        {POLICY_FIELDS.map(([k, label, u]) => {
          const ok = `override_${k}`;
          return on ? (
            <L key={k} label={label}><input type="number" step="any" data-testid={`fact-${ok}`} placeholder={pol ? `${pol[k]}` : ""} className={`${inputCls} font-mono`} value={f[ok] ?? ""} onChange={(e) => set(ok, e.target.value)} /></L>
          ) : (
            <div key={k} className="p-3 rounded-md bg-[#090D16] border border-[#1E293B]" data-testid={`fact-policy-${k}`}>
              <div className="font-mono text-[10px] tracking-[0.15em] text-[#6B7280]">{label}</div>
              <div className="font-mono font-bold">{pol ? `${fmt(pol[k])}${u}` : "…"}</div>
              <div className="font-mono text-[9px] text-[#38BDF8]">{pol?.source[k] === "item" ? "ITEM" : "GLOBAL"}</div>
            </div>
          );
        })}
      </div>
      {on && <div className="text-[11px] text-[#6B7280]">Blank fields fall back to the global value (shown as placeholder). Untick to return fully to global policy.</div>}
      {f.tier === 1 && (on ? (
        <L label="UNIT COST UPDATE ENGINE"><select data-testid="fact-override_cost_engine" className={inputCls} value={f.override_cost_engine || ""} onChange={(e) => set("override_cost_engine", e.target.value)}>
          <option value="">Global default</option><option value="wac">Weighted Average (WAC)</option><option value="latest">Latest Cost</option></select></L>
      ) : pol && (
        <div className="font-mono text-[11px] text-[#9CA3AF]" data-testid="fact-policy-cost-engine">COST ENGINE {pol.cost_engine === "latest" ? "LATEST COST" : "WEIGHTED AVERAGE"} <span className="text-[#38BDF8]">{pol.source.cost_engine === "item" ? "ITEM" : "GLOBAL"}</span></div>
      ))}
      {pol && (
        <div className="font-mono text-[11px] text-[#9CA3AF]" data-testid="fact-policy-par">
          ADCR {fmt(pol.adcr)}/d · LEAD {pol.lead_time_days}d · SUGGESTED PAR {pol.suggested_par ?? "—"}
          {pol.par_drift_pct != null && <span className={pol.drifting ? "text-[#F59E0B]" : ""}> · DRIFT {pol.par_drift_pct > 0 ? "+" : ""}{pol.par_drift_pct}%</span>}
        </div>
      )}
    </div>
  );
}
